module.exports = __webpack_public_path__ + "img/132.6.bc9af40e.png";